const errorMessages = {
  missingDataFromServer: "Ingen data ble returnert fra serveren",
  validationErrorsOnPage: "Det er {0} felter med ugyldig informasjon, vennligst rett disse og prøv igjen."
};

export default errorMessages;